import * as types from "../types_usage";
import axios from "axios/index";
import authHeader from "../../authHeader";

const state = {
  tableRef: null,
  manyRecordsAlert: false,
  usage: {
    isLoading: false,
    isError: false,
    errorMessage: null,
    data: null,
    filter: {
      dateFrom: null,
      dateTo: null,
      partyId: null,
      partyName: null,
      pageHitMin: 0,
      pageHitMax: 0,
      partyType: "organization", // do not delete this
      partner: "", // do not delete this
      ipRange: null,
      paidType: [],
    },
  },
};

function describeError(error) {
  if (error.response) {
    const status = error.response.status;
    if (status === 401) return "Session expired. Please log in again.";
    if (status === 403) return "You do not have permission for this action.";
    const serverMsg =
      error.response.data && (error.response.data.message || error.response.data.error);
    if (serverMsg) return serverMsg;
    return "Server error (" + status + "). Please try again.";
  }
  if (error.request) return "No response from server. Please check your connection.";
  return error.message || "An unexpected error occurred.";
}

const getters = {
  isError: (state) => {
    return state.usage.isError;
  },
  isLoading: (state) => {
    return state.usage.isLoading;
  },
  errorMessage: (state) => {
    return state.usage.errorMessage;
  },
  data: (state) => {
    return state.usage.data;
  },
  filter: (state) => {
    return state.usage.filter;
  },
  manyRecordsAlert: (state) => {
    return state.manyRecordsAlert;
  },
};

const actions = {
  [types.USG_ACTION_MANY_RECORDS_ALERT]: (context, payload) => {
    context.state.manyRecordsAlert = payload;
  },
  setTableRef: (context, tableRef) => {
    context.state.tableRef = tableRef;
  },
  setFilter: (context, payload) => {
    context.state.usage.filter = payload;
    context.state.usage.isLoading = true;
    context.state.usage.isError = false;
    context.state.usage.errorMessage = null;
    axios({
      method: "POST",
      url: "/pageview_sessions/filter",
      data: context.state.usage.filter,
      headers: authHeader(),
    })
      .then((res) => {
        res.data = res.data.map((col) => {
          col["partnerId"] = payload.partner;
          return col;
        });
        context.state.usage.data = res.data;

        if (res.data.length >= 100000) {
          context.state.manyRecordsAlert = true;
        }

        context.state.tableRef.clear().draw();
        context.state.tableRef.rows.add(res.data).draw();
        context.state.usage.isLoading = false;
      })
      .catch((error) => {
        context.state.usage.isLoading = false;
        context.state.usage.isError = true;
        context.state.usage.errorMessage = describeError(error);
        console.error("Usage filter error:", error);
      });
  },
  getUsageByActivationCode: (context, payload) => {
    context.state.usage.isLoading = true;
    context.state.usage.isError = false;
    context.state.usage.errorMessage = null;
    axios({
      method: "GET",
      url: "/pageview_sessions/activationCode",
      params: { activationCode: payload },
      headers: authHeader(),
    })
      .then((res) => {
        res.data = res.data.map((col) => {
          col["partnerId"] = "tair";
          return col;
        });
        context.state.usage.data = res.data;
        context.state.tableRef.clear().draw();
        context.state.tableRef.rows.add(res.data).draw();
        context.state.usage.isLoading = false;
      })
      .catch((error) => {
        context.state.usage.isLoading = false;
        context.state.usage.isError = true;
        context.state.usage.errorMessage = describeError(error);
        console.error("Activation code usage error:", error);
      });
  },
  [types.USG_TWA_ACTION_FILTER]: (context, payload) => {
    context.state.usage.filter = payload;
    context.state.usage.isLoading = true;
    context.state.usage.isError = false;
    context.state.usage.errorMessage = null;
    axios({
      method: "POST",
      url: "/turnaways/filter",
      data: context.state.usage.filter,
      headers: { "Content-Type": "application/json; charset=utf-8" },
    })
      .then((res) => {
        console.log({ res });
        let tableCols = [
          {
            data: "ip",
            title: "IP Address",
            type: "string",
            render: null,
          },
        ];
        context.state.tableRef.clear().draw();
        context.state.tableRef.aoColumns = tableCols;
        context.state.usage.data = res.data;
        context.state.tableRef.rows.add(res.data).draw();
        context.state.usage.isLoading = false;
      })
      .catch((error) => {
        context.state.usage.isLoading = false;
        context.state.usage.isError = true;
        context.state.usage.errorMessage = describeError(error);
        console.error("Turnaways filter error:", error);
      });
  },
  assignUnitsToOrcid: (context, payload) => {
    return new Promise((resolve, reject) => {
      let headers = authHeader();
      headers["Content-Type"] = "application/json; charset=utf-8";
      axios({
        method: "POST",
        url: "/usage/orcid/assign",
        data: payload,
        headers: headers,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            reject(error.response.data);
          } else {
            reject({ error: describeError(error) });
          }
        });
    });
  },
  assignUnitsToOrcidBulk: (context, payload) => {
    return new Promise((resolve, reject) => {
      let headers = authHeader();
      headers["Content-Type"] = "application/json; charset=utf-8";
      axios({
        method: "POST",
        url: "/usage/orcid/assign-bulk",
        data: payload,
        headers: headers,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            reject(error.response.data);
          } else {
            reject({ error: describeError(error) });
          }
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/usage.js